<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>控股集团官网</el-breadcrumb-item>
      <el-breadcrumb-item>报名咨询</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入家长姓名" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.phone" @keyup.enter.native="clicksearch" placeholder="请输入手机号码" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="Name" label="姓名" min-width="5%"></el-table-column>
          <el-table-column prop="Phone" label="联系方式" min-width="5%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="10%"></el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->
    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyKgjtWebsiteConsulting',
  data () {
    return {
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      // 查询客户
      keywords: {
        name: '',
        phone: ''
      }
    }
  },
  mounted () {
    this.GetKgjtWebsiteConsultingNum()
    this.GetKgjtWebsiteConsultingList()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.GetKgjtWebsiteConsultingList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.GetKgjtWebsiteConsultingList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.GetKgjtWebsiteConsultingNum()
      this.GetKgjtWebsiteConsultingList()
    },
    GetKgjtWebsiteConsultingList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        name: that.keywords.name,
        phone: that.keywords.phone
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteConsultingList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    GetKgjtWebsiteConsultingNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: that.keywords.name,
        phone: that.keywords.phone
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteConsultingNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
